import { Pencil } from 'lucide-react'

import { IconActionButton, IconActionButtonProps } from '../icon-action-button'

const Component = (props: IconActionButtonProps) => (
  <IconActionButton icon={Pencil} tooltip="Editar" {...props} />
)

export default Component
